"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.heroParallaxAnimation = exports.carouselAnimation = exports.cardHoverAnimation = exports.horizontalTextImageAnimation = exports.formsAnimation = exports.staggerAnimInit = exports.staggerNewsChildrensInit = exports.heroAnimInit = exports.staggerColsChildrensInit = exports.staggerInit = void 0;
const gsap_1 = __importDefault(require("gsap"));
const all_1 = require("gsap/all");
gsap_1.default.registerPlugin(all_1.ScrollTrigger, all_1.SplitText);
all_1.ScrollTrigger.defaults({
    start: "top 80%",
    end: "bottom 20%",
});
const STAGGER_DELAY = 0.2;
function staggerInit() {
    const componentEls = document.querySelectorAll(".component:not(.hero):not(.simple-hero)");
    if (componentEls.length === 0) {
        return;
    }
    componentEls.forEach((componentEl) => {
        let staggerEls = gsap_1.default.utils.toArray("[data-stagger]", componentEl);
        if (staggerEls.length === 0) {
            return;
        }
        if (staggerEls.length) {
            gsap_1.default.from(staggerEls, {
                autoAlpha: 0,
                y: 25,
                // Aquí se agrega el desfase a la animación
                stagger: STAGGER_DELAY, // Desfase de 0.2 segundos entre cada elemento
                scrollTrigger: {
                    trigger: componentEl,
                },
            });
        }
    });
}
exports.staggerInit = staggerInit;
function staggerColsChildrensInit() {
    const colsEls = gsap_1.default.utils.toArray(["[class*='cols-']:not(.cols-1):not(.--react)"]);
    colsEls.map((el) => {
        if (el.classList.contains("--react")) {
            return;
        }
    });
    colsEls.forEach((colEl) => {
        let childrenOfCols = gsap_1.default.utils.toArray("[class*='cols-'] > *", colEl);
        // gsap.fromTo(
        //     childrenOfCols,
        //     {
        //         autoAlpha: 0,
        //         y: 10,
        //     },
        //     {
        //         autoAlpha: 1,
        //         y: 0,
        //         stagger: 0.3,
        //         scrollTrigger: {
        //             trigger: colEl,
        //             start: "top 80%",
        //             end: "bottom 20%",
        //         },
        //     },
        // );
        gsap_1.default.set(childrenOfCols, { opacity: 0, duration: 0.1, y: 10, ease: "power1.out" });
        const tl = gsap_1.default.timeline({
            scrollTrigger: {
                trigger: colEl,
            },
        });
        tl.to(childrenOfCols, {
            opacity: 1,
            y: 0,
            stagger: STAGGER_DELAY,
        }, 0);
    });
}
exports.staggerColsChildrensInit = staggerColsChildrensInit;
function heroAnimInit(className) {
    const componentEls = document.querySelectorAll(className);
    if (componentEls.length === 0) {
        return;
    }
    const tl = gsap_1.default.timeline({
        scrollTrigger: {
            trigger: className,
            start: "top 80%",
            end: "bottom 20%",
        },
    });
    if (componentEls.length > 0) {
        componentEls.forEach((componentEl) => {
            let staggerEls = gsap_1.default.utils.toArray("[data-stagger]", componentEl);
            if (staggerEls.length === 0) {
                return;
            }
            tl.to(staggerEls, {
                opacity: 1,
                y: 0,
                stagger: STAGGER_DELAY,
            });
        });
    }
}
exports.heroAnimInit = heroAnimInit;
function staggerNewsChildrensInit() {
    const newsEls = gsap_1.default.utils.toArray([".news"]);
    newsEls.forEach((newsEl) => {
        let childrenOfCols = gsap_1.default.utils.toArray(".news > *", newsEl);
        gsap_1.default.set(childrenOfCols, { opacity: 0, duration: 0.1, y: 10, ease: "power1.out" });
        const tl = gsap_1.default.timeline({
            scrollTrigger: {
                trigger: newsEl,
            },
        });
        tl.to(childrenOfCols, {
            opacity: 1,
            y: 0,
            stagger: STAGGER_DELAY,
        }, 0);
    });
}
exports.staggerNewsChildrensInit = staggerNewsChildrensInit;
function staggerAnimInit(classes = []) {
    const classesString = classes.join(", ");
    const componentEls = document.querySelectorAll(classesString);
    componentEls.forEach((componentEl) => {
        let staggerEls = gsap_1.default.utils.toArray("[data-stagger]", componentEl);
        if (staggerEls.length) {
            gsap_1.default.to(staggerEls, {
                autoAlpha: 1,
                y: 0,
                // Aquí se agrega el desfase a la animación
                stagger: STAGGER_DELAY, // Desfase de 0.2 segundos entre cada elemento
                scrollTrigger: {
                    trigger: componentEl,
                },
            });
        }
    });
}
exports.staggerAnimInit = staggerAnimInit;
function formsAnimation() {
    const forms = document.querySelectorAll(".form");
    forms.forEach((form) => {
        let formRows = gsap_1.default.utils.toArray(".form-input-group", form), submitBtn = form.querySelector(".form-btn"), disclaimer = form.querySelector(".form-disclaimer");
        const tl = gsap_1.default.timeline({
            scrollTrigger: {
                trigger: form,
            },
        });
        tl.fromTo(formRows, {
            opacity: 0,
            y: 20,
        }, {
            opacity: 1,
            y: 0,
            stagger: 0.1,
        });
        tl.to([submitBtn, disclaimer], {
            opacity: 1,
            y: 0,
            stagger: 0.25,
        });
    });
}
exports.formsAnimation = formsAnimation;
function horizontalTextImageAnimation() {
    const horizontalTextImageElements = document.querySelectorAll(".horizontal-text-image");
    horizontalTextImageElements.forEach((element) => {
        const childElements = gsap_1.default.utils.toArray(".content > *", element);
        gsap_1.default.to(childElements, {
            y: 0,
            autoAlpha: 1,
            stagger: STAGGER_DELAY,
            scrollTrigger: {
                trigger: element.querySelector(".content"),
                start: "top 50%",
            },
        });
        // const tl = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: element,
        //         markers: true
        //     },
        // });
        // childElements.forEach((el, index) => {
        // if (el.hasAttribute("data-split")) {
        //     const split1 = new SplitText(el.querySelector('p'), { type: "lines", linesClass: `line-child-${index}` });
        //     const split2 =new SplitText(el.querySelector('p'), { type: "lines", linesClass: "line-parent" });
        //     const pElements = gsap.utils.toArray<HTMLElement>(`line-child-${index}`, el);
        //     tl.fromTo(
        //         pElements,
        //         {
        //             opacity: 0,
        //         },
        //         {
        //             // yPercent: 0,
        //             opacity: 1,
        //             // stagger: STAGGER_DELAY,
        //             // ease: "power3.out",
        //         },
        //     ).to(
        //         el,
        //         {
        //             y: 0,
        //             opacity: 1,
        //         },
        //         "<",
        //     );
        // } else {
        // tl.to(el, {
        //     y: 0,
        //     opacity: 1
        // });
        // }
        // });
    });
}
exports.horizontalTextImageAnimation = horizontalTextImageAnimation;
function cardHoverAnimation() {
    const cards = [...document.querySelectorAll(".card:has(a)")];
    if (cards.length === 0) {
        return;
    }
    cards.forEach((card) => {
        card.addEventListener("mouseenter", () => {
            gsap_1.default.to(card, {
                y: -5,
                duration: 0.2,
                boxShadow: "0 0 48px 0 #11111114",
                ease: "power1.in",
            });
        });
        card.addEventListener("mouseleave", () => {
            gsap_1.default.to(card, {
                y: 0,
                duration: 0.2,
                boxShadow: "none",
                ease: "power1.in",
            });
        });
    });
}
exports.cardHoverAnimation = cardHoverAnimation;
function carouselAnimation() {
    const carousels = document.querySelectorAll(".carousel");
    carousels.forEach((carousel) => {
        const splides = gsap_1.default.utils.toArray(".splide__slide", carousel);
        if (splides.length > 0) {
            gsap_1.default.from(splides, {
                autoAlpha: 0,
                stagger: STAGGER_DELAY,
                scrollTrigger: {
                    trigger: carousel,
                },
            });
        }
    });
}
exports.carouselAnimation = carouselAnimation;
function heroParallaxAnimation() {
    const heros = document.querySelectorAll(".hero:not(.--cotizaciones)");
    if (heros.length === 0) {
        return;
    }
    heros.forEach((hero) => {
        const content = hero.querySelector(".flex-content");
        gsap_1.default.to(content, {
            y: -100,
            stagger: STAGGER_DELAY,
            scrollTrigger: {
                trigger: hero,
                start: "top top",
                end: "bottom 30%",
                scrub: true,
            },
        });
    });
}
exports.heroParallaxAnimation = heroParallaxAnimation;
